export {
    genericPage,
    getServerSidePropsHelper,
    getMappingProgramaSlug,
    getMappingSeccio3CatInfo,
    getMappingEleccions3CatInfo,
    getSlugEleccio,
    getBasePathEleccio,
    getBasePathEleccioQA,
    isTv3,
    isCr,
    isSx3
} from '@portal-internet/components';
